import { lineConfig } from "./lineConfig"

/*
 * The logic behind line drawing.
 */

const lineDrawing = (fabricCanvas, fabric) => {

  let isDrawingLine = false
  let lineToDraw
  let pointer
  let pointerPoints

  fabricCanvas.on("mouse:down", (o) => {
    if (!fabricCanvas.isDrawingLineMode) return

    isDrawingLine = true
    pointer = fabricCanvas.getPointer(o.e)
    pointerPoints = [pointer.x, pointer.y, pointer.x, pointer.y]

    lineToDraw = new fabric.Line(pointerPoints, {
      strokeWidth: lineConfig.strokeWidth,
      stroke: lineConfig.stroke,
      strokeUniform: true,
      selectable: false,
      evented: false,
    })

    fabricCanvas.add(lineToDraw)
  })

  fabricCanvas.on("mouse:move", (o) => {
    if (!isDrawingLine) return

    pointer = fabricCanvas.getPointer(o.e)

    if (o.e.shiftKey) {
      const startX = pointerPoints[0]
      const startY = pointerPoints[1]
      const x2 = pointer.x - startX
      const y2 = pointer.y - startY
      const r = Math.sqrt(x2 * x2 + y2 * y2)
      let angle = (Math.atan2(y2, x2) * 180) / Math.PI

      angle = Math.round(angle / 15) * 15

      lineToDraw.set({
        x2: Math.cos((angle * Math.PI) / 180) * r + startX,
        y2: Math.sin((angle * Math.PI) / 180) * r + startY,
      })
    } else {
      lineToDraw.set({ x2: pointer.x, y2: pointer.y })
    }

    fabricCanvas.requestRenderAll()
  })

  fabricCanvas.on("mouse:up", () => {
    if (!isDrawingLine) return

    lineToDraw.setCoords()
    isDrawingLine = false
    fabricCanvas.trigger("object:modified")
  })
}

export default lineDrawing
